<template>
  <v-row no-gutters justify="start" class="rowContent my-0 py-4">
    <div>
      <ButtonLike
        size="large"
        :count="totalLike"
        :isLiked="isLiked"
        :entityId="entityId"
        :type="entityName"
        @onLike="$emit('onLike', arguments[0])"
      />
    </div>
    <div class="ml-4" @click="onReply">
      <v-btn icon small>
        <v-icon size="18" color="#828282">fal fa-reply</v-icon>
      </v-btn>
      <span class="text-md-subtitle-2 body-2 grey--text ml-1">
        <translate>Reply</translate>
      </span>
    </div>
  </v-row>
</template>
<script>
import ButtonLike from "@/components/Buttons/ButtonLike";
export default {
  name: "DiscussionPostAction",
  props: {
    entityId: {},
    entityName: {},
    isLiked: { type: Boolean, default: false },
    totalLike: { type: Number, default: null },
  },
  components: { ButtonLike },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  methods: {
    async onReply() {
      if (!this.token) {
        const toggle = await this.$store.state.toggle.dialogConfirm.open(
          this.$gettext("Warning"),
          this.$gettext('You need to login'),
          { color: "warning" }
        );
        if (!toggle) return
        this.$router.push({name: 'login'})
      } else {
        this.$emit("onReply", this.entityId);
      }

    },
  },
};
</script>
